import { Component, Vue, Watch } from 'vue-property-decorator'
import projectsService from '@/projects/services/projects-service'

@Component
export default class SidebarLayout extends Vue {
  private showSideMenu = false
  private hideOnScroll = false
  private projectName = ''

  // TODO: Obsolete: header in Zukunft konfigurierbar.
  get showHeader() {
    if (!this || !this.$route || !this.$route.meta) {
      return true
    }
    return this.$route.meta.showHeader || true
  }

  get headerColor() {
    if (!this || !this.$route || !this.$route.meta) {
      return 'transparent'
    }
    return this.$route.meta.headerColor || 'transparent'
  }

  get sideMenuEnabled() {
    if (!this || !this.$route || !this.$route.meta) {
      return true
    }
    // TODO: Sollte eigentlich sideMenuEnabled heißen
    return this.$route.meta.showSideMenu || true
  }

  public toggleSideMenu() {
    this.showSideMenu = !this.showSideMenu
    this.$bus.$emit('sidemenu:toggle')
  }

  // TODO: Obsolet, empty-layout verwenden
  get fullscreen() {
    if (!this || !this.$route || !this.$route.meta) {
      return false
    }
    return this.$route.meta.fullscreen || false
  }

  @Watch('$route', { immediate: true, deep: true })
  private async onUrlChangeAsync(newVal: any) {
    this.showSideMenu =
      this.sideMenuEnabled &&
      this.$vuetify.breakpoint.lgAndUp &&
      newVal.name !== 'login' &&
      newVal.name !== 'reset-password'

    this.projectName = ''
    if (newVal.name === 'projectDetail') {
      const p = await projectsService.findAsync(newVal.params['projectId'])
      if (p) {
        this.projectName = p.name
      }
    }
  }
}
